export default __webpack_public_path__ + "static/media/js.6397c2fd.png";